<template>
  <section class="admin-content" id="contact-search">
    <div class="bg-success m-b-30">
      <div class="container">
        <div class="row p-b-60 p-t-60">
          <div class="col-md-6 text-center mx-auto text-white p-b-30">
            <div class="m-b-10">
              <div class="avatar">
                <!-- <div class="avatar-title rounded-circle fe fe-briefcase"></div> -->
              </div>
            </div>
            <p class="h4">
              <strong>Voluntary Contributor Registration Form </strong>
            </p>
          </div>
        </div>
      </div>
    </div>

    <main class="admin-main">
      <section class="container">
        <div class="">
          <div class="row list justify-content-center">
            <div class="col-lg-12 col-md-12 mx-auto">
              <div class="card m-b-30" style="margin-top: 35px">
                <div class="card-body">
                  <div class="text-center">
                    <p>
                      (All fields marked with
                      <span class="text-danger">*</span> are compulsory)
                    </p>
                  </div>
                  <form @submit.prevent="submitForm">
                    <div class="form-row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="inputCity">Category<span class="text-danger">*</span></label>
                          <select class="form-control" required v-model="register.sector">
                            <option :value="sector.name" v-for="sector in sectors" :key="sector.name">
                              {{ sector.name }} ₦{{ sector.amount }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group col-md-6">
                        <label>NIN Number <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" required v-model="register.nimc_number"
                          placeholder="NIN Number" />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Surname <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" required v-model="register.lastname"
                          placeholder="Last Name" />
                      </div>
                      <div class="form-group col-md-6">
                        <label>First Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" required v-model="register.firstname"
                          placeholder="First Name" />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Middle Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" required v-model="register.middlename" placeholder="Middle Name" />
                      </div>

                      <!-- </div>

                                                         <div class="form-row"> -->
                      <div class="form-group col-md-6">
                        <p>
                          <label for="inputPassword4">Date of Birth: </label>
                        </p>

                        <input type="date" required class="form-control" v-model="register.dob"
                          placeholder="DD/MM/YYYY" />
                      </div>

                      <div class="form-group col-md-6">
                        <label>Email <span class="text-danger">*</span></label>
                        <input type="email" class="form-control" required v-model="register.email" placeholder="Email" />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputPassword4">Phone Number
                          <span class="text-danger">*</span></label>
                        <input v-phone type="tel" class="form-control" required v-model="register.phone_number"
                          placeholder="Phone Number" />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputCity">Gender <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.gender">
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Marital Status
                          <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.marital_status">
                          <option value="Married">Married</option>
                          <option value="Widow">Widow</option>
                          <option value="Single">Single</option>
                          <option value="Separated">Separated</option>
                          <option value="Divorced">Divorced</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity">LGA <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.localgovt" @change="fetchWards($event)">
                          <option v-for="lga in lga_states" v-bind:key="lga" :value="lga.id">
                            {{ lga.local_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Ward <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.ward">
                          <option v-for="ward in wards" v-bind:key="ward.id" :value="ward.id">
                            {{ ward.ward_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Select Organization</label>
                        <v-select v-model="register.place_of_work" :options="mdas" label="name"
                          :reduce="name => name.name" placeholder="Search organization…"></v-select>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Principal Facility for Accessing Healthcare <span class="text-danger">*</span>
                        <button @click="getProviders" type="button" class="btn btn-outline-info btn-sm my-1" title="Show every facility in the state">All</button>
                        </label>
                        <v-select v-model="register.provider_id" required :options="providers" label="agency_name"
                          :value="register.provider_id"></v-select>
                        <small v-if="register.localgovt && !(providers || []).length" class="text-muted d-block mt-1">No facility listed for this LGA or ward. Click <b>All</b> to choose from every facility in the state.</small>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity">Blood Group <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.blood">
                          <option value="A+">A+</option>
                          <option value="A-">A-</option>
                          <option value="B+">B+</option>
                          <option value="B-">B-</option>
                          <option value="AB+">AB+</option>
                          <option value="AB-">AB-</option>
                          <option value="O+">O+</option>
                          <option value="O-">O-</option>
                        </select>
                      </div>

                      <div class="form-group col-md-12">
                        <label for="inputAddress">Home Address <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" required v-model="register.address" placeholder="1234 Main St" />
                      </div>


                      <div class="form-group col-md-12">
                        <label class="small font-weight-bold text-secondary">Photo</label>
                        <div>
                          <button class="btn btn-outline-info mr-2" type="button" @click="takePicAndroid">
                            <i class="fe fe-camera mr-1"></i> Take Photo
                          </button>
                          <button class="btn btn-outline-secondary" type="button" @click="$refs.photoUpload.click()">
                            <i class="fe fe-upload mr-1"></i> Upload Image
                          </button>
                          <input
                            ref="photoUpload"
                            type="file"
                            accept="image/*"
                            style="display: none;"
                            @change="attachPic"
                          />
                        </div>
                        <div v-if="register.user_image" class="mt-2 d-flex align-items-center" style="gap: 10px;">
                          <img :src="register.user_image" class="rounded"
                            style="width: 80px; height: 80px; object-fit: cover; border: 2px solid #17a2b8;"
                            alt="User Photo" onerror="this.onerror=null; this.src='/assets/img/claimify_logo.png'" />
                          <button type="button" class="btn btn-sm btn-outline-danger" @click="register.user_image = ''">
                            <i class="fe fe-trash-2 mr-1"></i> Remove
                          </button>
                        </div>
                      </div>

                    <div class="form-group col-md-6" style="display:none;">
                      <img v-if="register.user_image" :src="`${register.user_image}`" class="rounded" alt="User Photo"
                        onerror="this.onerror=null; this.src='/assets/img/claimify_logo.png'" />

                    </div>


                    </div>
                    <div>
                      <p class="mb-2">
                        <strong>
                          Declaration & warranty on behalf of all persons
                          proposed to be insured</strong>
                      </p>

                      <div class="form-group">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="declaration1"
                            v-model="declarations.declaration1"
                          />
                          <label class="form-check-label" for="declaration1">
                            I/We hereby declare, on my behalf and on behalf of
                            all persons proposed to be insured that the above
                            statements, answers and/or particulars given by me
                            are true and complete in all respects to the best of
                            my knowledge and that I/We am/ are authorized to
                            propose on behalf of these other persons.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="declaration2"
                            v-model="declarations.declaration2"
                          />
                          <label class="form-check-label" for="declaration2">
                            I understand that the information provided by me
                            will form the basis of insurance policy, is subject
                            to the Board approved underwriting policy of RIVCHPP
                            and that the policy will come into force only after
                            full receipt of the premium chargeable.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="declaration3"
                            v-model="declarations.declaration3"
                          />
                          <label class="form-check-label" for="declaration3">
                            I/ We further declare that I/We will notify in
                            writing any change occurring in the occupation or
                            general health of the life to be insured/ proposer
                            after the proposal has been submitted but before
                            communication of the risk acceptance by RIVCHPP.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="declaration4"
                            v-model="declarations.declaration4"
                          />
                          <label class="form-check-label" for="declaration4">
                            I/We declare and consent to RIVCHPP seeking medical
                            information from any hospital who at any time has
                            attended on the life to be insured/ proposer or from
                            any past or present employer concerning anything
                            which affects the physical and mental health of the
                            life to be assured/proposer and seeking information
                            from any insurance company to which an application
                            for insurance on the life to be assured/ proposer
                            has been made for the purpose of underwriting the
                            proposal and/or claim settlement.
                          </label>
                        </div>
                      </div>

                      
                      <div class="form-group">
                        <div class="form-check">
                          <input required class="form-check-input" type="checkbox" id="checkbox1" />
                          <label class="form-check-label" for="checkbox1">
                            I/We agree to RIVCHPP 60-day wating period after registration
                            before accessing care. This is for official documentation
                            reasons.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="declaration5"
                            v-model="declarations.declaration5"
                          />
                          <label class="form-check-label" for="declaration5">
                            I/ We authorize RIVCHPP to share information
                            pertaining to my proposal including the medical
                            records for the sole purpose of proposal
                            underwriting and/or claims settlement and with any
                            Governmental and/or Regulatory Authority.
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="payment-instruction-box">
                      <h6 class="mb-2">Payment Instructions</h6>
                      <p class="mb-1" v-if="user">
                        Review your details before proceeding. You can either click <strong>Make Payment</strong>
                        and complete payment in the Paystack popup, or click <strong>Submit Without Payment</strong>
                        to continue directly.
                      </p>
                      <p class="mb-1" v-else>
                        Review your details before proceeding. Click <strong>Make Payment</strong>
                        once and complete payment in the Paystack popup.
                      </p>
                      <p class="mb-1">
                        Amount to pay: <strong>NGN {{ paymentAmount / 100 }}</strong>
                      </p>
                      <p class="mb-0">
                        After successful payment, your registration will be completed automatically and you will be redirected to your enrollee slip.
                      </p>
                      <p class="mb-0 mt-2 text-danger" v-if="!allDeclarationsAccepted">
                        Please tick all declaration checkboxes above to enable payment.
                      </p>
                    </div>

                    <div class="form-group">
                      <button
                        class="btn btn-success btn-block btn-lg"
                        type="submit"
                        :disabled="!allDeclarationsAccepted"
                      >
                        <paystack
                          v-if="allDeclarationsAccepted"
                          :amount="paymentAmount"
                          :email="register.email"
                          :paystackkey="paystackkey"
                          :reference="reference"
                          :callback="callback"
                          :first_name="register.firstname"
                          :last_name="register.lastname"
                          :phone="register.phone_number"
                          :close="close"
                          :embed="false"
                          class="col-md-12"
                        >
                          Make Payment <i class="fe fe-credit-card"></i>
                        </paystack>
                        <span v-else>
                          Make Payment <i class="fe fe-credit-card"></i>
                        </span>
                      </button>

                      <button
                        v-if="user"
                        class="btn btn-outline-dark btn-block btn-lg mt-2"
                        type="button"
                        :disabled="!allDeclarationsAccepted"
                        @click="submitWithoutPayment"
                      >
                        Submit Without Payment <i class="fe fe-check-circle"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="vld-parent">
              <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
            </div>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
  // Import component
  import Loading from "vue-loading-overlay";
  import paystack from "vue-paystack";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // import FacilitiesJSON from "@/jsons/paid_facilities.json";
  import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";

  export default {
    components: {
      Loading,
      paystack,
    },
    data() {
      return {
        user: null,
        isLoading: false,
        fullPage: true,
        states: "",
        show: false,
        clients: "",
        // providers: FacilitiesJSON,
        providers: "",
        sector: "informal",
        mdas: "",
        wards: "",
        sectors: [
          {
            name: "Rivcare",
            amount: 25000,
          },
          {
            name: "Rivcare Basic",
            amount: 38500,
          },
          {
            name: "Rivcare Premium",
            amount: 68500,
          },
          {
            name: "Rivcare Premium Plus",
            amount: 98500,
          },
        ],
        providers_wards: "",
        paystackkey: "pk_live_873084ab876aad40fe062000ee5a706de1b16f30",
    //  paystackkey: "pk_test_6555651ecaf3d32f6c6a49dd81f875f06be5f332", //paystack public key

        state: "",
        OfficerDetails: "",
        current_page: "",
        image: "",
        imagefile: null,
        lga_states: "",
        response: "",
        declarations: {
          declaration1: false,
          declaration2: false,
          declaration3: false,
          declaration4: false,
          declaration5: false,
        },
        register: {
          firstname: "",
          lastname: "",
          middlename: "",
          user_image: "",
          nimc_number: "",
          email: "",
          phone_number: "",
          type: "client",
          agency_id: "",
          state: "",
          localgovt: "",
          ward: "",
          address: "",
          blood: "",
          gender: "",
          genotype: "",
          dob: "",
          expiry_date: new Date(),
          salary_number: "",
          provider_id: "",
          point_of_care: "",
          sector: "",
          finger_print: "",
          place_of_work: "",
          org_id: "",
          grade_level: "",
          date_of_entry: "",
          marital_status: "",
          category_of_vulnerable_group: "",
        },
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));

    },
    computed: {
      addYear() {
        var d = new Date();
        var year = d.getFullYear();
        var month = d.getMonth();
        var day = d.getDate();
        var c = new Date(year + 1, month, day);
        // var c = new Date(year + 1);
        console.log(c);
        return c;
      },
      reference() {
        let text = "";
        let possible =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (let i = 0; i < 20; i++) {
          text += possible.charAt(Math.floor(Math.random() * possible.length));
        }

        return text;
      },
      paymentAmount() {
        let plan = this.sectors.find((x) => x.name == this.register.sector);
        return plan ? plan.amount * 100 : 0;
      },
      allDeclarationsAccepted() {
        return Object.values(this.declarations).every(Boolean);
      },
    },

    methods: {
      validateRequiredFields() {
        if (!this.register.sector) {
          this.$toasted.error("Please select a Category.", { position: "top-center", duration: 3000 });
          return false;
        }
        if (!this.register.localgovt) {
          this.$toasted.error("Please select an LGA.", { position: "top-center", duration: 3000 });
          return false;
        }
        if (!this.register.provider_id) {
          this.$toasted.error("Please select a Principal Facility.", { position: "top-center", duration: 3000 });
          return false;
        }
        return true;
      },

      submitForm() {
        this.$toasted.info("Click Make Payment to continue.", {
          position: "top-center",
          duration: 2000,
        });
      },

      submitWithoutPayment() {
        if (!this.user) {
          this.$toasted.error("Payment is required for non-logged-in users.", {
            position: "top-center",
            duration: 3000,
          });
          return;
        }

        if (!this.allDeclarationsAccepted) {
          this.$toasted.error("Please accept all declarations before submitting.", {
            position: "top-center",
            duration: 3000,
          });
          return;
        }

        if (!this.validateRequiredFields()) return;

        this.registerUserAdmin(null);
      },

      callback(response) {
        if (!response || !response.reference) {
          this.$toasted.error("Payment reference not found.", {
            position: "top-center",
            duration: 3000,
          });
          return;
        }

        if (!this.validateRequiredFields()) return;

        this.registerUserAdmin(response.reference);
      },

      close() {
        this.$toasted.info("Payment window closed.", {
          position: "top-center",
          duration: 2000,
        });
      },

      fetchWards() {
        this.axios
          .get(`/api/v1/auth/getwards/${event.target.value}`)
          .then((response) => {
            this.wards = response.data.data;
            this.getProvidersByLGAs();
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      fetchLga() {
        this.axios
          .get(`/api/v1/auth/lga/2679`)
          .then((response) => {
            this.lga_states = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      registerUserAdmin(paymentReference) {
        this.isLoading = true;
        const hasPayment = !!paymentReference;
        let providerId =
          this.register.provider_id && this.register.provider_id.id
            ? this.register.provider_id.id
            : this.register.provider_id;

        this.axios
          .post("/api/v1/auth/register", {
            nimc_number: this.register.nimc_number,
            firstname: this.register.firstname.toUpperCase(),
            lastname: this.register.lastname.toUpperCase(),
            middlename: this.register.middlename.toUpperCase(),
            email: this.register.email,
            plan_type: this.register.plan_type,
            phone_number: this.register.phone_number,
            type: this.register.type,
            sectorType: "Individual",
            user_image: this.register.user_image,
            agency_id: 407465,
            provider_id: providerId,
            state: "2679",
            role: 0,
            password: "jacobi",
            org_id: 0,
            localgovt: this.register.localgovt,
            ward: this.register.ward,
            blood: this.register.blood,
            dob: this.register.dob,
            address1: this.register.address,
            genotype: this.register.genotype,
            gender: this.register.gender,
            sector: this.register.sector,
            place_of_work: this.register.place_of_work,
            point_of_care: providerId,
            finger_print: this.register.finger_print,
            salary_number: this.register.salary_number,
            grade_level: this.register.grade_level,
            date_of_entry: this.register.date_of_entry,
            marital_status: this.register.marital_status,
            category_of_vulnerable_group:
              this.register.category_of_vulnerable_group,
            enrolled_by: this.user == null ? 0 : this.user.id,
            payment_reference: paymentReference,
          })
          .then((response) => {
            console.log(response);
            let user_id = response.data.data.id;
            if (hasPayment) {
              this.recordPayment(user_id, paymentReference);
            }

            this.$toasted.success(hasPayment
              ? "Payment successful. Registration completed."
              : "Registration completed without payment.",
            { position: "top-center", duration: 5000 });

            this.isLoading = false;
            this.$router.push(`/enrollee_slip/${user_id}`);
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;

            this.response = error.response.data.errors;
            this.$toasted.error(`${JSON.stringify(this.response)}`, {
              position: "top-center",
              duration: 3000,
            });
          });
      },

      recordPayment(userId, paymentReference) {
        let plan = this.sectors.find((x) => x.name == this.register.sector);
        let amount = plan ? plan.amount : 0;

        if (!userId || !amount) {
          return;
        }

        this.axios
          .post("/api/v1/make/transaction", {
            agency_id: 407465,
            amount: amount,
            description: "RIVCHPP Plan Payment",
            type: "plan_payment",
            transaction_ref: paymentReference,
            user_id: userId,
          })
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            console.log(error.response);
          });
      },

      getMDAs() {
        this.axios
          .get(`/api/v1/auth/ministries/407465`, { params: { type: 'private' } })
          .then((response) => { this.mdas = response.data.data; })
          .catch((error) => { console.error(error); });
      },

      getProviders() {
        this.axios
          .get(`/api/v1/auth/providerAgency/407465`, {
            params: {
              status: 1,
            },
          })
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getProvidersByLGAs() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(
            `/api/v1/auth/providerAgencies/407465/${this.register.localgovt}`,
            {
              params: {
                status: 1,
              },
            }
          )
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getProvidersByWards() {
        this.axios
          .get(
            `/api/v1/auth/providerAgencies/407465/${this.register.localgovt}/${this.register.ward}`
          )
          .then((response) => {
            this.providers_wards = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      async takePicAndroid() {
        const image = await Camera.getPhoto({
          quality: 90,
          allowEditing: false,
          resultType: CameraResultType.Base64,
          source: CameraSource.Camera,
        });

        var imageUrl = image.base64String;
        this.register.user_image = "data:image/jpeg;base64," + imageUrl;
        this.$toasted.info("Image taken Successfully!", {
          position: "top-center",
          duration: 8000,
        });
      },
      attachPic(event) {
        let imageFile = event.target.files[0];

        if (imageFile) {
          const reader = new FileReader();

          reader.onload = (e) => {
            // The result contains the Base64 string
            let base64Data = e.target.result;
            console.log(base64Data); // You can use the Base64 string here
            this.register.user_image = base64Data;
          };

          reader.readAsDataURL(imageFile);
        }
      },
      

    },
    created() {
      this.fetchLga();
      this.getMDAs();
    },
  };
</script>

<style scoped>
.payment-instruction-box {
  background: #fff7e6;
  border: 2px solid #ffb84d;
  border-left: 6px solid #e67700;
  border-radius: 8px;
  color: #663c00;
  padding: 14px 16px;
  margin-bottom: 14px;
}

.payment-instruction-box h6 {
  color: #8f4c00;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
</style>